import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AnalyticsDirectivesModule } from '@analytics/events';
import { CoreJssProxyModule } from '@core/jss-proxy';
import { CoreTranslateModule } from '@core/translate';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SearchBarComponent, SearchTriggerComponent } from '@search/ui';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CommonUiUtilityComponentsModule } from '@legacy/common-ui-utility-components';
import {
  NgbCollapseModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import {
  CrntButton,
  CrntIcon,
  CrntIconButton,
  CrntVisuallyHidden,
} from '@essent/current-web-angular';
import { NavigationServiceButtonComponent } from '@core/navigation-ui/navigation-service-button';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { ScIconPipe } from '@core/jss-utils';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import { ListItemComponent } from '@legacy/common-ui-partials';

import { DrilldownNavComponent } from './shared/drilldown-nav/drilldown-nav.component';
import { EcmpHeaderImageComponent } from './shared/ecmp-header-image/ecmp-header-image.component';
import { HeaderToolsContainerComponent } from './shared/header-tools-container/header-tools-container.component';
import { HeaderToolsComponent } from './shared/header-tools/header-tools.component';
import {
  MinimalHeaderComponent,
  MinimalHeaderContainerComponent,
} from './shared/minimal-header';
import { NavbarDropdownComponent } from './shared/navbar-dropdown/navbar-dropdown.component';
import { NavItemToJssRoutePipe } from './shared/navbar-item/nav-item-to-jss-route.pipe';
import { NavbarItemComponent } from './shared/navbar-item/navbar-item.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { CollapseDirectionPipe } from './shared/off-canvas/collapse-direction.pipe';
import { OffCanvasComponent } from './shared/off-canvas/off-canvas.component';
import { SidebarNavContainerComponent } from './sidebar-nav/sidebar-nav-container/sidebar-nav-container.component';
import { SidebarNavComponent } from './sidebar-nav/sidebar-nav.component';

@NgModule({
  imports: [
    CommonModule,
    CoreJssProxyModule,
    FontAwesomeModule,
    RouterModule,
    NgbCollapseModule,
    NgbDropdownModule,
    DeployUrlPipe,
    SearchTriggerComponent,
    SearchBarComponent,
    AnalyticsDirectivesModule,
    CoreTranslateModule,
    AutomationIdDirective,
    CommonUiUtilityComponentsModule,
    CrntButton,
    CrntIconButton,
    CrntIcon,
    CrntVisuallyHidden,
    NavigationServiceButtonComponent,
    ScIconPipe,
    CSCaptureDirective,
    ListItemComponent,
    SidebarNavComponent,
    NavbarComponent,
    NavbarItemComponent,
    HeaderToolsComponent,
    HeaderToolsContainerComponent,
    SidebarNavContainerComponent,
    OffCanvasComponent,
    NavItemToJssRoutePipe,
    CollapseDirectionPipe,
    NavbarDropdownComponent,
    MinimalHeaderContainerComponent,
    MinimalHeaderComponent,
    EcmpHeaderImageComponent,
    DrilldownNavComponent,
  ],
  exports: [
    SidebarNavComponent,
    NavbarComponent,
    NavbarItemComponent,
    HeaderToolsComponent,
    HeaderToolsContainerComponent,
    SidebarNavContainerComponent,
    OffCanvasComponent,
    NavItemToJssRoutePipe,
    CollapseDirectionPipe,
    NavbarDropdownComponent,
    CommonUiUtilityComponentsModule,
    EcmpHeaderImageComponent,
    DrilldownNavComponent,
    FontAwesomeModule,
    AnalyticsDirectivesModule,
    CommonModule,
    CoreTranslateModule,
    AutomationIdDirective,
    NgbDropdownModule,
  ],
})
export class NavigationSharedModule {}
